export enum DocTypes {
  QUOTE = "Generate Quote",
  ESTIMATE = "Generate Estimate",
  PROJECT_INFORMATION_SHEET = "Project Information Sheet",
  TAX_EXEMPT_CERTIFICATE = "Tax Exemption Certificate",
  BOND_INFO_DOCUMENT = "Bond Info Document",
  BOND_INFORMATION = "Bond Information",
  SUB_CONTRACTOR_INFORMATION = "Subcontractor Information",
  GENERAL_CONTRACTOR_INFORMATION = "General Contractor Information",
  PROPERTY_OWNER_INFORMATION = "Property Owner Information",
  PROPERTY_LEGAL_DESCRIPTION = "Property Legal Description",
  PROJECT_INFO_SECTION = "Project Info Section",
  CASH_CREDIT_SALE_DOCUMENTS = "Cash or Credit Sale Documents",
  DEPRECATED_TAX_EXEMPT_CERTIFICATE = "Tax Exemption Certificate (Deprecated)",
  DEPRECATED_BOND_INFO_DOCUMENT = "Bond Info Document (Deprecated)",
  DEPRECATED_PROJECT_INFORMATION_SHEET = "Project Information Sheet (Deprecated)",
}
